const getRandomInt = (min, max) => {
  min = Math.ceil(min);
  max = Math.floor(max);
  return Math.floor(Math.random() * (max - min + 1)) + min;
};

const facts = [];

for (let i = 1; i <= 10; i++) {
  const fact = {
    key: i,
    text: `goal_fact_text_${i}`,
  };

  facts.push(fact);
}

const factKeyRandom = getRandomInt(0, 0);

const getRandomFact = () => facts[factKeyRandom];

export default getRandomFact;
